export default __webpack_public_path__ + "static/related-do-7fc9dd62c100fbe2bfbac69e9347c8fcb4d03061a3b9f9d6c9b1aa70094363de.png";